import React from "react";

import styled from "styled-components";

import Text from "components/atoms/text/Text";
import { ModalContainer, ModalDescText } from "components/page/modal/styled";
import AbstractModal from "components/page/modal/AbstractModal";

const Section = styled.div`
    margin-top: 20px;

    &:first-child {
        margin-top: 0;
    }
`;

const RuleList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;
`;

const RuleItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

const Bullet = styled.span`
    margin-top: 7px;
    width: 4px;
    height: 4px;
    border-radius: 999px;
    background-color: var(--color-SubBlack);
    flex-shrink: 0;
`;

const ExampleBox = styled.div`
    margin-top: 12px;
    padding: 12px;
    border-radius: 8px;
    background-color: var(--color-Base1);
`;

const SectionTitle = styled(Text).attrs({
    variant: "body-md-400",
    fontWeight: "600",
})``;

const RuleText = styled(Text).attrs({
    variant: "body-md-400",
})``;

const ExampleText = styled(Text).attrs((props) => ({
    variant: "body-md-400",
    margin: props.margin,
}))``;

function SearchSyntaxGuideModal(props) {
    return (
        <AbstractModal
            modalTitle="검색식 규칙"
            width={560}
            exitModal={props.exitModal}
            footer={{
                onlyLeftBtn: true,
                leftBtnText: "닫기",
                leftOnClick: props.exitModal,
            }}
        >
            <ModalContainer>
                <ModalDescText>
                    검색식에는 아래의 연산자를 사용할 수 있습니다. 공백은 AND, <code>|</code> 는 OR,
                    <code>!</code> 는 제외 조건입니다.
                </ModalDescText>

                <Section>
                    <SectionTitle>기본 규칙</SectionTitle>
                    <RuleList>
                        <RuleItem>
                            <Bullet />
                            <RuleText>{`() : 우선순위가 가장 높은 그룹 연산자`}</RuleText>
                        </RuleItem>
                        <RuleItem>
                            <Bullet />
                            <RuleText>{`공백 : AND 검색. 두 개의 검색어(식)을 모두 포함하고 있는 문서 검색`}</RuleText>
                        </RuleItem>
                        <RuleItem>
                            <Bullet />
                            <RuleText>{`| : OR 검색. 두 개의 검색어(식) 중 하나 이상 포함하고 있는 문서 검색`}</RuleText>
                        </RuleItem>
                        <RuleItem>
                            <Bullet />
                            <RuleText>{`! : NOT 이후에 있는 검색어가 포함된 문서는 제외`}</RuleText>
                        </RuleItem>
                        <RuleItem>
                            <Bullet />
                            <RuleText>{`* : 검색어의 *란에 0개 이상의 임의의 문자가 포함된 문서 검색`}</RuleText>
                        </RuleItem>
                        <RuleItem>
                            <Bullet />
                            <RuleText>{`"..." : 따옴표 내의 구문과 완전히 일치하는 문서만 검색`}</RuleText>
                        </RuleItem>
                    </RuleList>
                </Section>

                <Section>
                    <SectionTitle>예시</SectionTitle>
                    <ExampleBox>
                        <ExampleText>{`(나노 (기계 | machine))`}</ExampleText>
                        <ExampleText margin="8px 0 0 0">{`줄기세포 | 면역`}</ExampleText>
                        <ExampleText margin="8px 0 0 0">{`황금 !백금`}</ExampleText>
                        <ExampleText margin="8px 0 0 0">{`semi*`}</ExampleText>
                        <ExampleText margin="8px 0 0 0">{`"Transform and Quantization"`}</ExampleText>
                    </ExampleBox>
                </Section>
                <Section>
                    <SectionTitle>주의사항</SectionTitle>
                    <RuleList>
                        <RuleItem>
                            <Bullet />
                            <RuleText>{`사용자 편의를 위해 검색식 기호를 사용하지 않은 경우에는 자동으로 공백을 OR 로 해석합니다.`}</RuleText>
                        </RuleItem>
                    </RuleList>
                </Section>
            </ModalContainer>
        </AbstractModal>
    );
}

export default SearchSyntaxGuideModal;
